export { default as UserMenuConfig } from "./UserMenuConfig"